import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { ColumnPayload, UserSettingsResponse } from '../../../types/User';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updateUserColumns = async (formData: ColumnPayload): Promise<UserSettingsResponse> => {
  const response = await CustomAxios.put('user-columns', { settings: formData });
  return response.data;
};

export function useUpdateUserColumns() {
  return useMutation({
    mutationFn: (formData: ColumnPayload) => updateUserColumns(formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.currentUserSettings] });
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const data: UserSettingsResponse = err.response.data as UserSettingsResponse;
        queryClient.setQueryData([queryKeys.currentUserSettings], data);
      }
    },
  });
}
